/**
 * Utility for managing local storage with expiration
 */

/**
 * Saves data to local storage with a unique key and expiration (TTL)
 * @param {string} key Unique key for the storage
 * @param {any} value Data to store
 * @param {number} ttlInHours Time to live in hours
 */
export const saveWithExpiry = (key, value, ttlInHours = 48) => {
    const now = new Date();
    const item = {
        value: value,
        expiry: now.getTime() + ttlInHours * 60 * 60 * 1000,
    };
    localStorage.setItem(key, JSON.stringify(item));
};

/**
 * Retrieves data from local storage, checking for expiration
 * @param {string} key Unique key for the storage
 * @returns {any|null} Data if valid, null if expired or not found
 */
export const getWithExpiry = (key) => {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    try {
        const item = JSON.parse(itemStr);
        const now = new Date();

        if (now.getTime() > item.expiry) {
            localStorage.removeItem(key);
            return null;
        }
        return item.value;
    } catch (e) {
        console.error('Error parsing storage item', e);
        return null;
    }
};

/**
 * Removes data from local storage
 * @param {string} key Unique key for the storage
 */
export const removeStorage = (key) => {
    localStorage.removeItem(key);
};
